import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useModalContext } from "../../../../../../../_metronic/elements/Modal";
import AppSelect from "../../../../../../shared/AppSelect";
import { useIsMobile } from "../../../../../../shared/responsive";
import PrescriptionModalHeader from "./PrescriptionModalHeader";

const ModalFooter = ({ isMobile }) => {
  const modal = useModalContext();
  const { t } = useTranslation();

  return (
    <div className={`modal-footer prescription-modal__footer ${isMobile ? "prescription-modal__footer--mobile" : ""}`.trim()}>
      <button type="button" className="btn btn-light prescription-modal__footer-button" onClick={() => modal.hideModal()}>
        {t("prescription:count.buttons.cancel")}
      </button>
      <button type="submit" className="btn btn-primary prescription-modal__footer-button">
        {t("prescription:count.buttons.accept")}
      </button>
    </div>
  )
}

const PrescriptionCount = ({ setCountClasses, setNextStep }) => {
  const [cls, setCls] = useState(2);
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const onSubmit = (e) => {
    e.preventDefault();
    setCountClasses(cls)
    setNextStep(true);
  }

  return (
    <>
      <form onSubmit={onSubmit} className='form'>
        <PrescriptionModalHeader
          descriptionKey="prescription:count.description"
          isMobile={isMobile}
          titleKey="prescription:count.title"
        />
        <div className={`modal-body prescription-modal__body ${isMobile ? "prescription-modal__body--mobile" : ""}`.trim()}>
          {isMobile ? (
            <div className="prescription-count-mobile">
              <div className="prescription-count-mobile__grid" role="list" aria-label={t("prescription:count.classes_aria")}>
                {[2, 3, 4, 5, 6, 7].map((option) => (
                  <button
                    key={option}
                    type="button"
                    onClick={() => setCls(option)}
                    className={`prescription-count-mobile__option ${cls === option ? "active" : ""}`.trim()}
                  >
                    <span className="prescription-count-mobile__value">{option}</span>
                    <span className="prescription-count-mobile__label">{t("prescription:count.classes_label")}</span>
                  </button>
                ))}
              </div>
            </div>
          ) : (
            <AppSelect
              ariaLabel={t("prescription:count.classes_aria")}
              onChange={(nextValue) => setCls(Number(nextValue))}
              options={[2, 3, 4, 5, 6, 7].map((option) => ({
                label: String(option),
                value: option,
              }))}
              value={cls}
            />
          )}
        </div>
        <ModalFooter isMobile={isMobile} />
      </form>
    </>
  );
};

export default PrescriptionCount;
